import { css } from '@emotion/css';
import { Theme } from '@mui/material';

export const useLoginButtonStyles = (theme: Theme) => {
  return {
    loginButton: css({
      marginRight: theme.spacing(2),
    }),
    signUpButton: css({
      marginLeft: theme.spacing(2),
    }),
  };
};
